import React from 'react'
import RenderRoutes from './routes/Route'
import { Toaster } from 'react-hot-toast'

const App = () => {
  return (
    <>
    <Toaster />
      <RenderRoutes />
    </>
  )
}

export default App
